import React, { useMemo } from "react";
import { Snackbar } from "@akashnetwork/ui/components";
import { useSnackbar } from "notistack";
import { SUPPORT_EMAIL } from "@src/config/ui.config";
function errorMessageWithSupport(message: string) {
  return <div data-sentry-component="errorMessageWithSupport" data-sentry-source-file="useNotificator.tsx">
      <div>{message}</div>
      <div className="mt-2 text-xs">
        Need help? Contact{" "}
        <a href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent("Console Error")}&body=${encodeURIComponent(message)}`} className="underline">
          {SUPPORT_EMAIL}
        </a>
      </div>
    </div>;
}
export function useNotificator() {
  const {
    enqueueSnackbar
  } = useSnackbar();
  return useMemo(() => ({
    success: (message: string, options?: {
      dataTestId: string;
    }) => {
      enqueueSnackbar(<Snackbar data-testid={options?.dataTestId} title="Success" subTitle={message} />, {
        variant: "success",
        autoHideDuration: 3000
      });
    },
    error: (message: string, options?: {
      dataTestId?: string;
      title?: string;
    }) => {
      enqueueSnackbar(<Snackbar data-testid={options?.dataTestId} title={options?.title || "Error"} subTitle={errorMessageWithSupport(message)} />, {
        variant: "error",
        autoHideDuration: 10000
      });
    }
  }), [enqueueSnackbar]);
}